exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".salaryInput-c6a33{padding:0}.salaryInput-c6a33 input{padding:8px 12px}", ""]);

// Exports
exports.locals = {
	"salaryInput": "salaryInput-c6a33"
};